var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"right-item-content"},_vm._l((_vm.notices),function(item){return _c('div',{key:item.id,staticClass:"right-item-view",on:{"click":function($event){return _vm.handleClick(item)}}},[_c('div',[_vm._v(_vm._s(item.title))]),_c('div',{staticStyle:{"font-family":"12px"}},[_vm._v(_vm._s(item.createTime))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }